import React from "react";
import { CertificationInformationContainer } from ".";
import { CertificationLearningPath } from "@components/CertificationLearningPath";
import { PageProps, graphql } from "gatsby";
import { sortBy } from "lodash";

export default function Certification({
  location,
  data: { certification },
}: PageProps<Queries.GetCertificationAndCoursesQuery>) {
  if (!certification) {
    throw new Error("Unable to locate certification");
  }

  return (
    <CertificationInformationContainer
      uri={location.pathname}
      certification={certification}
    >
      <CertificationLearningPath
        courses={sortBy(certification.courses, "slug")}
        exam={certification.exam}
      />
    </CertificationInformationContainer>
  );
}

export const query = graphql`
  query GetCertificationAndCourses($id: String!) {
    certification(id: { eq: $id }) {
      id
      slug
      title
      description
      tagline
      criteria
      image
      courses {
        id
        slug
        title
        description
      }
      exam {
        id
        slug
      }
    }
  }
`;
